
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    hideAllInfo,
    hideLayerInfoForm,
    initHideButton,
    showLayerInfoButton
} from "@/helpers/layer/info/layer-info-helper";
import {
    clearInfoCharacteristics,
    isInfoCharacteristicsLoaded
} from "@/helpers/layer/info/layer-info-characteristics-helper";

export class LayerInfoBookmarkInfoButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-button data-icon="fa fa-info-circle" data-title="openLayerMenu"></layer-info-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const element = document.querySelectorAll('bookmark-info')[0]
            const classList = [...element.classList]

            hideLayerInfoForm()

            if(classList.includes('d-none')) {
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')
            } else {
                hideAllInfo()
            }
        })
    }
}

